import axios from "axios";
import { apiErrorHandler } from "./helper/handler";

const prefix = "queue";

const GET_ALL_ROOM_URL = `${prefix}/all-room`;
const GET_DOCTOR_QUEUE_URL = `${prefix}/get-doctor-queue`;
const GET_DOCTOR_QUEUE_DISPLAY_URL = `${prefix}/get-doctor-queue-display`;
const GET_QUEUE_MEDICATION_URL = `${prefix}/get-queue-medication`;
const GET_QUEUE_MEDICATION_DISPLAY_URL = `${prefix}/get-queue-medication-display`;
const GET_QUEUE_FINANCE_URL = `${prefix}/get-queue-finance`;
const GET_QUEUE_FINANCE_DISPLAY_URL = `${prefix}/get-queue-finance-display`;
const UPDATE_DOCTOR_QUEUE_URL = `${prefix}/update-by-id`;
const UPDATE_CASHIER_QUEUE_URL = `${prefix}/update-cashier-queue-by-id`;
const CHECK_STATUS_FINANCE_URL = `${prefix}/check-status-finance-call`;
const GET_LAB_XRAY_URL = `${prefix}/get-lab-xray`;

/**
 * @func getQueueRoom
 * @desc get queue room
 * @author jew
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {Array} user array
 */
export const getQueueRoom = async (queryParams, signal) => {
    try {
        const { data, status } = await axios.get(GET_ALL_ROOM_URL, {
            params: queryParams,
            signal,
        });
        if (status === 200) {
            return data;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "getQueueRoom");
        if (err) throw err;
        return undefined;
    }
};
/** End @func getQueueRoom */

/**
 * @func getDoctorQueue
 * @desc get doctor queue
 * @author jew
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {Object} doctor queue data
 */
export const getDoctorQueue = async (queryParams, signal) => {
    try {
        const { data, status } = await axios.get(GET_DOCTOR_QUEUE_URL, {
            params: queryParams,
            signal,
        });
        if (status === 200) {
            return data;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "getDoctorQueue");
        if (err) throw err;
        return undefined;
    }
};
/** End @func getDoctorQueue */

/**
 * @func getDoctorQueueDisplay
 * @desc get doctor queue display
 * @author jew
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {Object} doctor queue display data
 */
export const getDoctorQueueDisplay = async (queryParams, signal) => {
    try {
        const { data, status } = await axios.get(GET_DOCTOR_QUEUE_DISPLAY_URL, {
            params: queryParams,
            signal,
        });
        if (status === 200) {
            return data;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "getDoctorQueueDisplay");
        if (err) throw err;
        return undefined;
    }
};
/** End @func getDoctorQueueDisplay */

/**
 * @func getQueueMedication
 * @desc get all user data
 * @author jew
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {Array} user array
 */
export const getQueueMedication = async (queryParams, signal) => {
    try {
        const { data, status } = await axios.get(GET_QUEUE_MEDICATION_URL, {
            params: queryParams,
            signal,
            baseURL: "medicine",
        });
        if (status === 200) {
            return data;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "getQueueMedication");
        if (err) throw err;
        return undefined;
    }
};
/** End @func getQueueMedication */

/**
 * @func getQueueMedicationDisplay
 * @desc get all user data
 * @author jew
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {Array} user array
 */
export const getQueueMedicationDisplay = async (queryParams, signal) => {
    try {
        const { data, status } = await axios.get(GET_QUEUE_MEDICATION_DISPLAY_URL, {
            params: queryParams,
            signal,
            baseURL: "medicine",
        });
        if (status === 200) {
            return data;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "getQueueMedicationDisplay");
        if (err) throw err;
        return undefined;
    }
};
/** End @func getQueueMedicationDisplay */

/**
 * @func getQueueFinance
 * @desc get all user data
 * @author jew
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {Array} user array
 */
export const getQueueFinance = async (queryParams, signal) => {
    try {
        const { data, status } = await axios.get(GET_QUEUE_FINANCE_URL, {
            params: queryParams,
            signal,
            baseURL: "payment",
        });
        if (status === 200) {
            return data;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "getQueueFinance");
        if (err) throw err;
        return undefined;
    }
};
/** End @func getQueueFinance */

/**
 * @func getQueueFinanceDisplay
 * @desc get all user data
 * @author jew
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {Array} user array
 */
export const getQueueFinanceDisplay = async (queryParams, signal) => {
    try {
        const { data, status } = await axios.get(GET_QUEUE_FINANCE_DISPLAY_URL, {
            params: queryParams,
            signal,
            baseURL: "payment",
        });
        if (status === 200) {
            return data;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "getQueueFinanceDisplay");
        if (err) throw err;
        return undefined;
    }
};
/** End @func getQueueFinanceDisplay */

/**
 * @func checkStatusFinance
 * @desc get all user data
 * @author jew
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {Array} user array
 */
export const checkStatusFinance = async (queryParams, signal) => {
    try {
        const { data, status } = await axios.get(CHECK_STATUS_FINANCE_URL, {
            params: queryParams,
            signal,
            baseURL: "payment",
        });
        if (status === 200) {
            return data;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "checkStatusFinance");
        if (err) throw err;
        return undefined;
    }
};
/** End @func checkStatusFinance */

/**
 * @func updateDoctorQueueById
 * @desc update doctor queue by id
 * @author jew
 * @param {number} id - doctor queue id
 * @param {Object} body - update doctor queue body
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {boolean} update status
 */
export const updateDoctorQueueById = async (id, body, signal) => {
    try {
        const { status } = await axios.put(`${UPDATE_DOCTOR_QUEUE_URL}/${id}`, body, {
            signal,
        });
        if (status === 200) {
            return true;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "updateDoctorQueueById");
        if (err) throw err;
        return undefined;
    }
};
/** End @func updateDoctorQueueById */

/**
 * @func updateCashierQueueMedicineById
 * @desc update cashier queue by id (medicine queue)
 * @author jew
 * @param {number} id - cashier queue id
 * @param {Object} body - update cashier queue body
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {boolean} update status
 */
export const updateCashierQueueMedicineById = async (id, body, signal) => {
    try {
        const { status } = await axios.put(`${UPDATE_CASHIER_QUEUE_URL}/${id}`, body, {
            signal,
            baseURL: "medicine",
        });
        if (status === 200) {
            return true;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "updateCashierQueueMedicineById");
        if (err) throw err;
        return undefined;
    }
};
/** End @func updateCashierQueueMedicineById */

/**
 * @func updateCashierQueuePaymentById
 * @desc update cashier queue by id (medicine queue)
 * @author jew
 * @param {number} id - cashier queue id
 * @param {Object} body - update cashier queue body
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {boolean} update status
 */
export const updateCashierQueuePaymentById = async (id, body, signal) => {
    try {
        const { status } = await axios.put(`${UPDATE_CASHIER_QUEUE_URL}/${id}`, body, {
            signal,
            baseURL: "payment",
        });
        if (status === 200) {
            return true;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "updateCashierQueuePaymentById");
        if (err) throw err;
        return undefined;
    }
};
/** End @func updateCashierQueuePaymentById */

/**
 * @func getLabAndXray
 * @desc get all user data
 * @author jew
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {Array} user array
 */
export const getLabAndXray = async (queryParams, signal) => {
    try {
        const { data, status } = await axios.get(GET_LAB_XRAY_URL, {
            params: queryParams,
            signal,
        });
        if (status === 200) {
            return data;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "getLabAndXray");
        if (err) throw err;
        return undefined;
    }
};
/** End @func getLabAndXray */
